var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.errors, function (error, index) {
      return _c("div", { key: index, staticClass: "text-danger" }, [
        _vm._v("\n\t\t" + _vm._s(error) + "\n\t"),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }